
import { useState } from 'react';
import { GET_TICKET_BY_EXERCISE } from '../../app/api/apiRoutes';
import { Assort } from '../../app/models/Assort';
import useFacility from './useFacility';
import useApiRequest from "../../utils/hooks/useApiRequest"

export default function useGetTicketAndPasses() {
  const { get } = useApiRequest();
  const facilityIds = useFacility();
  const [tickets, setTickets] = useState<Assort[]>([]);


 const getTicketsByExercise = async (id: number) => {
  const exerciseGroupIds = `0,${id}`
  const { result, isError } = await get(GET_TICKET_BY_EXERCISE(facilityIds,exerciseGroupIds));
  if (!isError) {
    setTickets(result);
  }
}; 
return {
  getTicketsByExercise,
  tickets,
}
}

